import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../data/mockData';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-950 to-gray-900 text-white">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="/images/logo-maesi.png" 
              alt="MAESI Logo" 
              className="h-12 w-auto brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              {companyInfo.fullName}. Más de 25 años diseñando y fabricando soluciones de maquinaria industrial de alta calidad.
            </p>
            <div className="flex gap-3">
              {companyInfo.social.facebook && (
                <a 
                  href={companyInfo.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center hover:bg-blue-700 transition-colors"
                >
                  <Facebook className="w-5 h-5" />
                </a>
              )}
              {companyInfo.social.instagram && (
                <a 
                  href={companyInfo.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center hover:from-purple-700 hover:to-pink-700 transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-blue-400">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/equipos" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Equipos
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-blue-400">Nuestros Productos</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>• Llenadoras Industriales</li>
              <li>• Etiquetadoras</li>
              <li>• Agitadores</li>
              <li>• Transportadores</li>
              <li>• Tanques de Proceso</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-blue-400">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-gray-300">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span>{companyInfo.location.fullAddress}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-300">
                <Phone className="w-5 h-5 text-blue-400" />
                <div className="flex flex-col">
                  <a href={`tel:${companyInfo.contact.phone}`} className="hover:text-blue-400 transition-colors">
                    {companyInfo.contact.phone}
                  </a>
                  <a href={`tel:${companyInfo.contact.phone2}`} className="hover:text-blue-400 transition-colors">
                    {companyInfo.contact.phone2}
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-300">
                <Mail className="w-5 h-5 text-blue-400" />
                <a href={`mailto:${companyInfo.contact.email}`} className="hover:text-blue-400 transition-colors break-all">
                  {companyInfo.contact.email}
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-300">
                <Clock className="w-5 h-5 text-blue-400" />
                <span>Lun - Vie: 9:00 AM - 6:30 PM</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© {currentYear} MAESI. Todos los derechos reservados.</p>
            <p>Diseñado con precisión y calidad | Maquinaria Industrial de Excelencia</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
